import { render, staticRenderFns } from "./TheModalFooter.vue?vue&type=template&id=9751b182&scoped=true"
import script from "./TheModalFooter.vue?vue&type=script&lang=ts"
export * from "./TheModalFooter.vue?vue&type=script&lang=ts"
import style0 from "./TheModalFooter.vue?vue&type=style&index=0&id=9751b182&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9751b182",
  null
  
)

export default component.exports